"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAssignationOfferRepostInfo = getAssignationOfferRepostInfo;
const legacy_config_1 = require("@daytrip/legacy-config");
const legacy_enums_1 = require("@daytrip/legacy-enums");
const utils_1 = require("@daytrip/utils");
const assignation_offer_claim_statuses_1 = require("../../../assignation-offer-claim/constants/assignation-offer-claim-statuses");
const INCORRECT_OFFER_STATUS_RESTRICTION = "Offer is not in the correct status for reposting.";
const MAX_REPOST_LIMIT_REACHED_RESTRICTION = "Offer reposts limit reached.";
const BIDDING_OFFER_RESTRICTION = "Bidding offer cannot be reposted.";
const INVALID_OFFER_RESTRICTION = "Invalid offer cannot be reposted.";
const ACTIVE_ASSIGNATION_OFFER_CLAIMS_RESTRICTION = "Offer with active claims cannot be reposted.";
const URGENT_TRIP_RESTRICTION = "Urgent trip cannot be reposted.";
const MANUALLY_CREATED_OFFER_RESTRICTION = "Manually created offers with positive subsidy cannot be reposted.";
function getAssignationOfferRepostInfo(offer, isValid) {
    const restrictions = [];
    if (offer.status !== legacy_enums_1.AssignationOfferStatus.Created) {
        restrictions.push(INCORRECT_OFFER_STATUS_RESTRICTION);
    }
    if (offer.repostCount >= legacy_config_1.MAX_ASSIGNATION_OFFER_REPOST_LIMIT) {
        restrictions.push(MAX_REPOST_LIMIT_REACHED_RESTRICTION);
    }
    if (offer.type === legacy_enums_1.AssignationOfferTypeEnum.Bidding) {
        restrictions.push(BIDDING_OFFER_RESTRICTION);
    }
    // Invalid offer should be manually reposted for the amount decided by DS
    if (isValid === false) {
        restrictions.push(INVALID_OFFER_RESTRICTION);
    }
    const activeClaims = offer.claims?.filter(({ status }) => assignation_offer_claim_statuses_1.ACTIVE_ASSIGNATION_OFFER_CLAIM_STATUSES.includes(status));
    if (activeClaims?.length) {
        restrictions.push(ACTIVE_ASSIGNATION_OFFER_CLAIMS_RESTRICTION);
    }
    const daysToDeparture = (0, utils_1.getTimeDiffInDays)(offer.departureAtUtc, offer.createdAt);
    const isUrgentTrip = daysToDeparture < legacy_config_1.LAST_MINUTE_ORDER_THRESHOLD_IN_HOURS / 24;
    const urgentOfferRepostAllowed = offer.repostCount === 0 && legacy_config_1.URGENT_OFFERS_REPOST_ENABLED;
    if (isUrgentTrip && !urgentOfferRepostAllowed) {
        restrictions.push(URGENT_TRIP_RESTRICTION);
    }
    const offerSubsidy = offer.subsidy || 0;
    if (offer.createdByUserId && offerSubsidy > 0) {
        restrictions.push(MANUALLY_CREATED_OFFER_RESTRICTION);
    }
    return {
        info: restrictions.length ? restrictions.join(" ") : "No restrictions for reposting detected.",
        canBeReposted: restrictions.length === 0,
    };
}
//# sourceMappingURL=get-assignation-offer-repost-info.js.map